import { render, staticRenderFns } from "./AdminPreloader.vue?vue&type=template&id=44bcbcdc"
import script from "./AdminPreloader.vue?vue&type=script&lang=js"
export * from "./AdminPreloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bcbcdc')) {
      api.createRecord('44bcbcdc', component.options)
    } else {
      api.reload('44bcbcdc', component.options)
    }
    module.hot.accept("./AdminPreloader.vue?vue&type=template&id=44bcbcdc", function () {
      api.rerender('44bcbcdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminPreloader.vue"
export default component.exports